import React from 'react';
import classnames from 'classnames';
import clamp from '../../../../common/utils/text-overflow-clamp';
import { getResizedImageUrl } from '../../../../common';
import { ScrollbarWrapper } from '../../../scrollbar-wrapper/scrollbar-wrapper';
import styles from './info.scss';
const POSTER_SIZE = {
    width: 303,
    height: 449,
};
const POSTER_SIZE_FULLSCREEN = {
    width: 450,
    height: 667,
};
// NOTE: Expected translated values at props (because of differrent translations at embed and widget)
export class Info extends React.Component {
    constructor() {
        super(...arguments);
        this.title = null;
        this.info = null;
        this.posterEl = null;
        this.savePosterRef = (node) => {
            this.posterEl = node;
        };
        this.saveTitleRef = (node) => {
            this.title = node;
        };
        this.setPosterSize = () => {
            const { isInFullScreen } = this.props;
            this.updatePosterStyle(isInFullScreen ? POSTER_SIZE_FULLSCREEN : POSTER_SIZE);
        };
    }
    componentDidMount() {
        this.clamp();
        this.setPosterSize();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.title && prevProps.title !== this.props.title) {
            this.clamp();
        }
        if (prevProps.isInFullScreen !== this.props.isInFullScreen) {
            this.setPosterSize();
        }
    }
    clamp() {
        if (!this.title) {
            return;
        }
        clamp(this.title, { lineClamp: 3 });
    }
    getRoles(rolesType, title) {
        const { [rolesType]: roles } = this.props;
        if (!roles || !roles.length) {
            return null;
        }
        const roleElements = roles.map(({ role, name }, index) => {
            if (!role) {
                return null;
            }
            return (React.createElement("div", { key: index, "data-hook": `overlay-info-${rolesType}`, className: styles['role-item'] },
                React.createElement("div", { className: styles.role }, role),
                React.createElement("div", { className: styles.name }, name)));
        });
        return (React.createElement("div", { className: styles['roles-wrapper'] },
            React.createElement("div", { className: styles['roles-title'] }, title),
            roleElements));
    }
    updatePosterStyle({ width, height }) {
        const poster = this.posterEl;
        if (!poster) {
            return;
        }
        poster.style.width = `${Math.floor((poster.offsetHeight / height) * width)}px`;
    }
    getPosterImage(width, height, className) {
        const { posterUrl, isInFullScreen, imageHost } = this.props;
        if (!posterUrl) {
            return null;
        }
        const resizedPosterUrl = getResizedImageUrl({
            url: posterUrl,
            width: width * 2,
            height: height * 2,
            imageHost,
        });
        const classNames = classnames(styles.poster, className, {
            [styles.fullscreen]: isInFullScreen,
        });
        return (React.createElement("div", { ref: this.savePosterRef, className: classNames, "data-hook": "overlay-info-poster", style: { backgroundImage: `url(${resizedPosterUrl})` } }));
    }
    get compactPoster() {
        const { posterUrl, title, imageHost } = this.props;
        if (!posterUrl) {
            return null;
        }
        const resizedPosterUrl = getResizedImageUrl({
            url: posterUrl,
            width: POSTER_SIZE.width * 2,
            height: POSTER_SIZE.height * 2,
            imageHost,
        });
        return (React.createElement("img", { className: `${styles.poster} ${styles['poster-compact']}`, "data-hook": "overlay-info-poster-compact", src: resizedPosterUrl, alt: title }));
    }
    get poster() {
        const { isInFullScreen } = this.props;
        if (isInFullScreen) {
            return null;
        }
        return this.getPosterImage(POSTER_SIZE.width, POSTER_SIZE.height);
    }
    get fullScreenPoster() {
        const { isInFullScreen } = this.props;
        if (!isInFullScreen) {
            return null;
        }
        return this.getPosterImage(POSTER_SIZE_FULLSCREEN.width, POSTER_SIZE_FULLSCREEN.height);
    }
    get publisher() {
        const { publisher, isRTL } = this.props;
        if (!publisher) {
            return null;
        }
        const publisherStyles = classnames(styles['info-item'], {
            [styles.rtl]: isRTL,
            [styles.ltr]: !isRTL,
        });
        return (React.createElement("div", { className: publisherStyles, "data-hook": "overlay-info-publisher" }, publisher));
    }
    get genre() {
        const { genre, isRTL } = this.props;
        if (!genre) {
            return null;
        }
        const genreStyles = classnames(styles['info-item'], {
            [styles.rtl]: isRTL,
            [styles.ltr]: !isRTL,
        });
        return (React.createElement("div", { className: genreStyles, "data-hook": "overlay-info-genres" }, genre));
    }
    get videoType() {
        const { videoType, isRTL } = this.props;
        if (!videoType) {
            return null;
        }
        const videoTypeStyles = classnames(styles['info-item'], {
            [styles.rtl]: isRTL,
            [styles.ltr]: !isRTL,
        });
        return (React.createElement("div", { className: videoTypeStyles, "data-hook": "overlay-info-video-type" }, videoType));
    }
    get duration() {
        const { durationStr, durationAriaLabel, isRTL } = this.props;
        if (!durationStr) {
            return null;
        }
        const durationStyles = classnames(styles['info-item'], {
            [styles.rtl]: isRTL,
            [styles.ltr]: !isRTL,
        });
        return (React.createElement("div", { className: durationStyles, "data-hook": "overlay-info-duration", "aria-label": durationAriaLabel }, ` ${durationStr}`));
    }
    get description() {
        const { description } = this.props;
        if (!description) {
            return null;
        }
        return (React.createElement("div", { className: styles.description, "data-hook": "overlay-info-description" }, description));
    }
    render() {
        const { title, isInFullScreen, castTitle, crewTitle } = this.props;
        const styleNames = classnames(styles.wrapper, {
            [styles['full-screen']]: isInFullScreen,
        });
        return (React.createElement("div", { className: styleNames, "data-hook": "player-overlay-info" },
            this.poster,
            React.createElement(ScrollbarWrapper, { className: styles['scrollbar-wrapper'] },
                React.createElement("div", { className: styles['main-info'] },
                    React.createElement("h3", { ref: this.saveTitleRef, className: styles.title, "data-hook": "overlay-info-title", title: title }, title),
                    React.createElement("div", { className: styles.info },
                        this.publisher,
                        this.genre,
                        this.videoType,
                        this.duration),
                    this.description,
                    this.fullScreenPoster,
                    this.getRoles('cast', castTitle),
                    this.getRoles('crew', crewTitle),
                    this.compactPoster))));
    }
}
//# sourceMappingURL=info.js.map